<template>
    <div class="single-pill">
        <div v-if="loading" class="loader-wrapper"><span class="loader red"></span></div>
        <transition name="long-fade">
            <div v-if="!loading && data">
                <ion-row v-if="image">
                    <ion-col size="12" size-md="8" offset-md="2" size-lg="8" offset-lg="2" size-xl="6" offset-xl="3" class="pd-0" >
                        <div class="image-wrapper">
                            <ion-img :src="image" class="image" :alt="title" />
                        </div>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12" size-sm="10" offset-sm="1" size-md="8" offset-md="2" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
                        <div class="padding">
                            <h1 class="h2 text-normal">{{ title }}</h1>
                            <p class="date mt-0">{{ dateFrom }} - {{ dateTo }}</p>
                        </div>
                    </ion-col>
                </ion-row>
                <ion-row >
                    <ion-col size="12" size-sm="10" offset-sm="1" size-md="8" offset-md="2" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
                        <div class="padding">
                            <article class="entry rte" v-html="content"></article>
                            <div v-if="showAnswerButton === true" class="mt-30">
                                <button  class="btn btn-primary btn-auto" @click="goToQuestion">odpowiedz na pytanie</button>
                            </div>
                        </div>
                    </ion-col>
                </ion-row>
            </div>
        </transition>
    </div>
</template>

<script>

    import PillsServices from '../../../services/KnowledgeServices';

    export default {
        name: 'PillSingle',
        props: {
            slug : {
                type: [String, Number],
                requred: true
            }
        },
        data: () =>({
            loading: true,
            data: null
        }),
        computed:{
            statusLabel(){
                return (this.data.status == 'active') ? 'Aktywna' : 'Zakonczona'
            },
            image(){
                return this.data.image;
            },
            title(){
                return this.data.title;
            },
            excerpt(){
                return this.data.excerpt;
            },
            content(){
                return this.data.content;
            },
            dateFrom(){
                return this.data.dateFrom;
            },
            dateTo(){
                return this.data.dateTo;
            },
            status(){
                return this.data.status;
            },
            question(){
                if(Array.isArray(this.data.questions) == true){
                    return this.data.questions && this.data.questions.length ? this.data.questions[0] : null;
                }
                return this.data.questions;

            },
            questionSlug(){
                return this.question ? this.question.slug : null;
            },
            isCorrectAnswer(){
                return this.question && (typeof this.question.isCorrectAnswer != 'undefined') ? this.question.isCorrectAnswer : null
            },
            isBlockedForAnotherAnswer(){
                return this.question && (typeof this.question.isBlockedForAnotherAnswer != 'undefined') ? this.question.isBlockedForAnotherAnswer : null
            },
            showAnswerButton(){
                return this.isBlockedForAnotherAnswer != null ?  (this.isBlockedForAnotherAnswer == false ? true : false) : false;
                //old version return this.status && this.status == true ? ( this.question.isBlockedForAnotherAnswer == true ? false : true ) : false;
            }
        },
        methods: {
            getData: function () {

                this.loading = true;
                PillsServices.getPill(this.slug)
                    .then( (response) => {
                        this.loading = false;
                        this.data = response.data.data;
                        // FIX scroll to top
                        const element = document.querySelector('#topOfDocument');
                        element.scrollIntoView()
                    })
                    .catch( (e) => {
                        this.errors.push(e.toString())
                    })
            },
            goToQuestion: function () {
                this.$router.push({ name: 'QuestionSingle', params: { slug: this.questionSlug } })
            }
        },
        mounted(){
            this.getData();
        }
    }
</script>